import React from 'react';
import { useLocation } from 'react-router-dom';

// @mui
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import * as http from '_core/utils/http';

// style
import { useStyle } from './style';

/*
  slots.jsx
    import { Iframe } from '_core/components/Iframe';
    import { Props } from 'basic/slots';
    
    Props(Iframe, { height: 'calibrate', src: '/iframe.html' })
  
  iframe.html:
    <script src="/data/jscript/global/calibrate-height.js"></script>
*/

let iframeID = 0;
const iframeData = {};

export const RawIframe = (props) => {
  const { width, height, src, onMessage } = props;

  const [calibrateHeight, setCalibrateHeight] = React.useState();
  
  const id = React.useRef();
  
  if (!id.current)
    id.current = ++iframeID;
  
  const { pathname } = useLocation();

  const {
    pages: { iframes }
  } = useTheme();

  const classes = useStyle();

  const iframeSrc = src || iframes[pathname];

  React.useEffect(() => {
    iframeData[id.current] = { setCalibrateHeight, onMessage };
    
    return () => delete iframeData[id.current];
  }, [iframeSrc, setCalibrateHeight, onMessage]);

  const iframeStyle = {};

  if (typeof width !== 'undefined') iframeStyle.width = width;

  if (height === 'calibrate') {
    iframeStyle.height = calibrateHeight;
  } else if (typeof height !== 'undefined') {
    iframeStyle.height = height;
  }

  return (
    <Box
      display="flex"
      className={height !== 'calibrate' ? classes.root : null}
    >
      <iframe
        src={
          height === 'calibrate'
            ? http.param(iframeSrc, { 'calibrate-id': id.current })
            : iframeSrc
        }
        className={classes.iframe}
        style={iframeStyle}
      />
    </Box>
  );
};

RawIframe.defaultProps = {};

RawIframe.propTypes = {};

export const Iframe = RawIframe;

const onMessage = (event) => {
  const { type, id, value } = event.data;
  
  if (!id) return;
  
  const data = iframeData[id];
  
  if (!data) return;
  
  const { onMessage, setCalibrateHeight } = data;
  
  if (typeof onMessage === 'function')
    onMessage(event.data);
  
  if (type !== 'calibrate-height') return;
  
  if (!setCalibrateHeight) return;
  
  setCalibrateHeight(value);
};

if (window.addEventListener) {
  window.addEventListener('message', onMessage, false);
} else if (window.attachEvent) {
  window.attachEvent('onmessage', onMessage, false);
}
